import { BackTop, Spin } from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { keepState } from './../../../actions/appAction';
import { fromSummary } from './../../../actions/headerAction';
import { onSubmit, onTab, update, setFulfillmentOption } from './../../../actions/shipmentAction';
import { shipperInfor } from './../../../actions/shipperInfor';
import { shipmentStatus, FulfillOption as FulfillOptionConst } from './../../../constants';
import { convertDateToUTC } from './../../../services/dst';
import { getShipmentParams, titleHead } from './../../../services/helper';
import Header from './../../../components/header';
import BoxUtility from './../components/box-utility';
import AddPackageInfor from './components/add-package-infor';
import Rows from './components/rows';
import DataExport from '../data-export';
import './styles.css';
import history from './../../../services/history'
import Storage from '../../../services/Storage';

let defaultParams = {
    IsDesc: true,
    OrderBy: "LastUpdateDT",
    Page: 1,
    PageSize: 50,
    SelectedIds: [],
}

class ListShipment extends Component {
    constructor(props) {
        super(props)
        const { type } = props.match.params;
        let FulfillmentFlg = Storage.get('FulfillmentFlg')
        if (!FulfillmentFlg && type) {
            history.push('/orders')
        } else if (FulfillmentFlg && !type) {
            history.push('/shipments/' + FulfillOptionConst.IN_HOUSE.TYPE_LINK)
        }
        let FulfillmentOption
        if (type === FulfillOptionConst.YAMATO.TYPE_LINK) {
            FulfillmentOption = FulfillOptionConst.YAMATO.CODE
            
        } else {
            FulfillmentOption = FulfillOptionConst.IN_HOUSE.CODE
        }
        this.props.setFulfillmentOption(FulfillmentOption);
        this.state = {
            FulfillmentOption
        }
    }

    static getDerivedStateFromProps(props, state) {
        let startToday = moment().format('MM/DD/YYYY') + ' 00:00:00'
        let endToday = moment().format('MM/DD/YYYY') + ' 23:59:59'
        const { type } = props.match.params;
        let Status = [];
        let FulfillmentOption = null;
        // set params default when is link shipment yamato
        if (type === FulfillOptionConst.YAMATO.TYPE_LINK) {
            Status = [shipmentStatus.FULFILLMENT_IN_PROCESS]
            FulfillmentOption = FulfillOptionConst.YAMATO.CODE
            
        } else {
            Status = [shipmentStatus.AWAITING_PACKAGE_INFO]
            FulfillmentOption = FulfillOptionConst.IN_HOUSE.CODE
        }

        defaultParams = {
            ...defaultParams,
            Status,
            FulfillmentOption,
        }
        if (state.typeListShipment && type !== state.typeListShipment) {
            if (props.FromSummary) {
                props.onTab({ tab: props.tab, PageSize: props.getShipmentParams.PageSize, FulfillmentOption: FulfillmentOption })
                props.fromSummary({ fromSummary: false })
            } else {
                let status_list = [];
                if (state.typeListShipment && type !== state.typeListShipment) {
                    status_list = Status;
                }
                props.setFulfillmentOption(FulfillmentOption)
                props.onSubmit({
                    ...defaultParams,
                    PageSize: props.getShipmentParams.PageSize,
                    Status: status_list,
                    SelectedIds: [],
                    TrackingNumberFrom: props.trackingNo,
                    TrackingNumberTo: props.trackingNo,
                    fromQS: true,
                    StartToday: convertDateToUTC(new Date(startToday)),
                    EndToday: convertDateToUTC(new Date(endToday)),
                })
                props.update({
                    offset: props.getShipmentParams.PageSize,
                    input_filter: {
                        status_list: status_list,
                        type_list: [],
                        channel_order_no: undefined,
                        channel: [],
                        order_date_from: undefined,
                        order_date_to: undefined,
                        shipping_date_from: undefined,
                        shipping_date_to: undefined,
                        tracking_number_from: undefined,
                        tracking_number_to: undefined,
                    },
                })
            }
            
        }
        return {
            typeListShipment: type,
            FulfillmentOption
        }
    }

    componentDidMount() {
        titleHead('List Shipment')

        // Fetch shipper information for MultiPackageFlg
        this.props.shipperInfor()

        let _this = this
        let startToday = moment().format('MM/DD/YYYY') + ' 00:00:00'
        let endToday = moment().format('MM/DD/YYYY') + ' 23:59:59'
        // When the user scrolls the page, execute myFunction
        window.onscroll = function () { myFunction() };

        // Get the header
        var header = document.getElementById("box-utility-shipments");
        var divHeader = document.getElementById("header")
        var topHeight = divHeader ? divHeader.clientHeight : 66;

        // Get the offset position of the navbar
        var sticky = header ? header.offsetTop : 0;

        function myFunction() {
            if (header) {
                if (window.pageYOffset > sticky + topHeight) {
                    if (_this.props.add_filter) {
                        header.classList.add("sticky-filter");
                    } else {
                        header.classList.add("sticky");
                    }
                } else {
                    header.classList.remove("sticky");
                    header.classList.remove("sticky-filter");
                }
            }
        }
        if (this.props.isKeepState) {
            this.props.onSubmit({ ...this.props.getShipmentParams, isKeepState: true })
            this.props.keepState(false)
        } else if (this.props.FromSummary) {
            this.props.onTab({ tab: this.props.tab, PageSize: this.props.getShipmentParams.PageSize, FulfillmentOption: this.state.FulfillmentOption })
            this.props.fromSummary({ fromSummary: false })
        } else {
            let fromOrigin = (history.location.state && history.location.state.from) ? history.location.state.from : null
            const { status_list } = this.props.shipment
            let status_list_new = [];
            if (status_list instanceof Array && status_list.length && fromOrigin !== '/orders') {
                status_list_new = status_list
            } else {
                if (this.state.typeListShipment === FulfillOptionConst.YAMATO.TYPE_LINK) {
                    status_list_new = [shipmentStatus.FULFILLMENT_IN_PROCESS]
                } else {
                    status_list_new = [shipmentStatus.AWAITING_PACKAGE_INFO]
                }
            }

            defaultParams.Status = status_list_new
            this.props.onSubmit({
                ...defaultParams,
                PageSize: this.props.getShipmentParams.PageSize,
                StartToday: convertDateToUTC(new Date(startToday)),
                EndToday: convertDateToUTC(new Date(endToday)),
            })
            this.props.update({
                offset: this.props.getShipmentParams.PageSize,
                input_filter: {
                    status_list: status_list_new,
                    type_list: [],
                    channel_order_no: undefined,
                    channel: [],
                    order_date_from: undefined,
                    order_date_to: undefined,
                    shipping_date_from: undefined,
                    shipping_date_to: undefined,
                    tracking_number_from: undefined,
                    tracking_number_to: undefined
                },
                add_filter: false,
            })
        }

    }

    renderDataExportModal = () => {
        if (this.props.isDataExportVisible) {
            return <DataExport />;
        }

        return null;
    }

    render() {
        return (
            <div id="shipments" className="list-shipment-wraper">
                <Header />
                <Spin spinning={this.props.getting_order} tip="Loading...">
                    <div className="wrap-content">
                        <div className="content">
                            <BoxUtility className=""
                                typeListShipment={this.state.typeListShipment}
                                redirect={this.props.history.push} />
                            <div id="div-content-shipment" className="content-shipment">
                                <AddPackageInfor />
                                <table className="table-orders">
                                    <Rows />
                                </table>
                            </div>
                        </div>
                    </div>
                </Spin>
                <BackTop />
                {this.renderDataExportModal()}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        getting_order: state.shipmentReducer.getting_order,
        getShipmentParams: getShipmentParams(state),
        add_filter: state.shipmentReducer.add_filter,
        isKeepState: state.appReducer.keepState,
        trackingNo: state.quickSearchReducer.tracking_no,
        FromSummary: state.headerReducer.fromSummary,
        tab: state.headerReducer.tab,
        shipment: state.shipmentReducer,
        isDataExportVisible: state.shipmentReducer.dataExportModalVisibility,
        shipperInformation: state.shipmentReducer.shipperInformation
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSubmit: payload => {
            dispatch(onSubmit(payload))
        },
        update: (payload) => {
            dispatch(update(payload))
        },
        keepState: (payload) => {
            dispatch(keepState(payload))
        },
        onTab: (payload) => {
            dispatch(onTab(payload))
        },
        fromSummary: (payload) => {
            dispatch(fromSummary(payload))
        },
        setFulfillmentOption: (payload) => {
            dispatch(setFulfillmentOption(payload))
        },
        shipperInfor: () => {
            dispatch(shipperInfor())
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ListShipment)



// WEBPACK FOOTER //
// ./src/containers/shipments/list/index.js